module.exports = __webpack_public_path__ + "img/stackoverflow.eb8790cb.svg";